import { render, staticRenderFns } from "./IconSoldOut.vue?vue&type=template&id=356e3063&"
import script from "./IconSoldOut.vue?vue&type=script&lang=ts&"
export * from "./IconSoldOut.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports